/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Rôle d'une garantie dans le calcul des primes dérivées de sa branche : none = hors calcul, base = sa prime pure entre dans l'assiette, catNat / catTech / attack = la garantie est la prime Cat Nat, Cat Tech ou Attentat, calculée comme un taux de la branche appliqué à l'assiette. Ignoré quand les primes dérivées sont désactivées sur la branche.
 * @export
 */
export const RolePrimeDerivee = {
    None: 'none',
    Base: 'base',
    CatNat: 'catNat',
    CatTech: 'catTech',
    Attack: 'attack'
} as const;
export type RolePrimeDerivee = typeof RolePrimeDerivee[keyof typeof RolePrimeDerivee];


export function instanceOfRolePrimeDerivee(value: any): boolean {
    for (const key in RolePrimeDerivee) {
        if (Object.prototype.hasOwnProperty.call(RolePrimeDerivee, key)) {
            if (RolePrimeDerivee[key as keyof typeof RolePrimeDerivee] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RolePrimeDeriveeFromJSON(json: any): RolePrimeDerivee {
    return RolePrimeDeriveeFromJSONTyped(json, false);
}

export function RolePrimeDeriveeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RolePrimeDerivee {
    return json as RolePrimeDerivee;
}

export function RolePrimeDeriveeToJSON(value?: RolePrimeDerivee | null): any {
    return value as any;
}

export function RolePrimeDeriveeToJSONTyped(value: any, ignoreDiscriminator: boolean): RolePrimeDerivee {
    return value as RolePrimeDerivee;
}

